module.exports = __webpack_public_path__ + "img/rsz_61d349a2268b8afa5cfcc0eb_logo___primary.05b16c99.png";